import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatasetService } from 'app/main/components/dataset/services/dataset.service';

interface ILogRow {
	id: string;
	log_type: string;
	message: string;
	user_message: string;
	extra: any;
	created_at: string;
	user_id: string | null;
	user_name: string | null;
	user_email: string | null;
}

interface IDialogData {
	participantId: string;
	participantDescription: string;
}

@Component({
	selector: 'actual-trip-participant-logs-dialog',
	templateUrl: './participant-logs-dialog.component.html',
	styleUrls: ['./participant-logs-dialog.component.scss']
})
export class ActualTripParticipantLogsDialogComponent implements OnInit {

	loading = false;
	logs: ILogRow[] = [];
	error: string | null = null;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: IDialogData,
		public dialogRef: MatDialogRef<ActualTripParticipantLogsDialogComponent>,
		private datasetService: DatasetService,
	) {}

	ngOnInit(): void {
		this.load();
	}

	load(): void {
		this.loading = true;
		this.error = null;
		this.datasetService.post<{ items: ILogRow[] }>(
			'/dataset/actual_trip_participants/command/get_logs',
			{ id: this.data.participantId }
		).subscribe({
			next: res => {
				this.logs = (res && res.items) ? res.items : [];
				this.loading = false;
			},
			error: () => {
				this.error = 'Errore caricamento log';
				this.loading = false;
			}
		});
	}

	getUserLabel(log: ILogRow): string {
		if (log.user_name) return log.user_name;
		if (log.user_email) return log.user_email;
		return '—';
	}

	getLogTypeLabel(logType: string): string {
		switch (logType) {
			case 'event:create':           return 'Creazione';
			case 'event:update':           return 'Modifica';
			case 'event:delete':           return 'Cancellazione';
			case 'event:command_executed': return 'Azione';
			case 'request':                return 'Richiesta';
			default:                       return logType;
		}
	}

	getChangeSummary(log: ILogRow): string | null {
		if (!log.extra) return null;
		const changes = log.extra.changes;
		if (!changes) return null;
		const parts: string[] = [];
		if (Object.prototype.hasOwnProperty.call(changes, 'presence')) {
			parts.push(changes.presence == 1 ? 'Presenza confermata' : 'Presenza rimossa');
		}
		if (Object.prototype.hasOwnProperty.call(changes, 'last_presence_checked_at')) {
			// noise, skip
		}
		const otherKeys = Object.keys(changes).filter(k => !['presence', 'last_presence_checked_at', 'last_presence_geo_positon', 'updated_at'].includes(k));
		otherKeys.forEach(k => parts.push(`${k}: ${changes[k]}`));
		return parts.length ? parts.join(' · ') : null;
	}

	close(): void {
		this.dialogRef.close();
	}
}
